<div class="row page-header">
    <div class="col-12">
        <h1>Quarterly Measurables <small>Define goals and enter quarterly results for the business plan dashboard</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <h3>Measurable Definitions</h3>
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        style="height: 280px; padding: 0"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        [itemFormatter]="itemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [minWidth]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Goal Label'" [binding]="'goalLabel'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Metric'" [binding]="'hrGoalName'" [width]="180"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Calculated Source'" [binding]="'calculatedSourceName'" [width]="180"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Goal Value'" [binding]="'goalValue'" [width]="100"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Direction'" [binding]="'goalDirection'" [width]="90"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Format'" [binding]="'format'" [width]="80"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Order'" [binding]="'order'" [width]="70"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Archived'" [binding]="'isArchived'" [width]="80"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>

            @if (dashboard) {
                <h3>Quarterly Results</h3>
                <div class="row mb-3 align-items-end">
                    <div class="col-auto">
                        <label for="quarterCount" class="form-label mb-0">Quarters to show</label>
                        <select
                            id="quarterCount"
                            class="form-select form-select-sm"
                            [(ngModel)]="quarterCount"
                            (ngModelChange)="onQuarterCountChanged()"
                        >
                            @for (opt of quarterCountOptions; track opt.value) {
                                <option [ngValue]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                    </div>
                    <div class="col">
                        <p class="text-muted small mb-0">
                            Calendar quarters (e.g. 2Q26). Linked metrics and calculated sources auto-fill cells; grey
                            text shows the computed value. Type a value to override; clear the cell to revert. Changes
                            save when you leave the cell.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-grid
                            id="resultsGrid"
                            #resultsFlexGrid
                            class="quarterly-results-grid"
                            appAutoSize
                            [padding]="20"
                            [frozenColumns]="2"
                            [keyActionTab]="'MoveAcross'"
                            (initialized)="resultsGrid.initialize(resultsFlexGrid)"
                            (destroy)="resultsGrid.destroy()"
                            [itemsSource]="resultsGrid.view"
                            [itemFormatter]="resultsItemFormatter"
                            (beginningEdit)="beginningEdit(resultsFlexGrid, $event)"
                            (cellEditEnded)="cellEditEnded(resultsFlexGrid, $event)"
                            (pasting)="pasting(resultsFlexGrid, $event)"
                        >
                            <wj-flex-grid-column
                                [header]="'Measurable'"
                                [binding]="'name'"
                                [width]="'*'"
                                [minWidth]="200"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Goal'"
                                [binding]="'goalLabel'"
                                [width]="120"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            @for (quarter of dashboard.quarters; track quarter.key) {
                                <wj-flex-grid-column
                                    [header]="quarter.name"
                                    [binding]="draftBinding(quarter.year, quarter.quarter)"
                                    [dataType]="'Number'"
                                    [isRequired]="false"
                                    [isReadOnly]="!canEdit"
                                    [align]="'right'"
                                    [width]="90"
                                ></wj-flex-grid-column>
                            }
                        </wj-flex-grid>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
